// ===== GROUP - SLIDER ON MOBILE
// ================================================================================

$('.wp-block-group.is-slider-on-mobile').each(function() {

    const $group = $(this);
	let swiper = null;
    let controls = '<div class="swiper-controls"><div class="swiper-arrow prev"><svg viewBox="0 0 10.29 16" xmlns="http://www.w3.org/2000/svg"><path d="M2.29 0L8 5.72 10.29 8l-8 8L0 13.71 5.71 8 0 2.29z"/></svg></div><div class="swiper-arrow next"><svg viewBox="0 0 10.29 16" xmlns="http://www.w3.org/2000/svg"><path d="M2.29 0L8 5.72 10.29 8l-8 8L0 13.71 5.71 8 0 2.29z"/></svg></div></div>';

	function initSwiper() {
		if (swiper) return;
		$group.addClass('swiper');
		$group.children().wrapAll('<div class="swiper-wrapper">');
		$group.find('> .swiper-wrapper > *').addClass('swiper-slide');
        $group.prepend(controls);
		swiper = new Swiper($group[0], {
            loop: true,
            navigation: {
                nextEl: $group.find('.swiper-arrow.next')[0],
                prevEl: $group.find('.swiper-arrow.prev')[0],
            },
            slidesPerView: 1.2,
			spaceBetween: 16,
			speed: 500,
		});
	}

	function destroySwiper() {
		if (!swiper) return;
		swiper.destroy(true, true);
		swiper = null;
		$group.find('> .swiper-wrapper > *').removeClass('swiper-slide').unwrap();
		$group.removeClass('swiper');
		$group.find('.swiper-controls').remove();
	}

	const mq = window.matchMedia('(max-width: 767px)');
	mq.addEventListener('change', e => e.matches ? initSwiper() : destroySwiper());
	if (mq.matches) initSwiper();

});